<template>
  <div class="dialog-modal">
    <div class="copy_dialog">
      <div class="dialog-body">
        <div class="alert-content">
          <i class="w-icon-qiangtixing icon-error font-14"></i>
          <p>存在一个或多个文件重名，是否替换？</p>
        </div>
      </div>
      <div class="dialog-foot">
        <w-button type="primary" @click.stop.prevent="btnClick(1)">替换</w-button>
        <w-button type="minor" @click.stop.prevent="btnClick(2)">追加</w-button>
        <w-button type="minor" @click.stop.prevent="btnClick(3)">跳过</w-button>
        <!--<a class="ui-btn ui-btn_blue" @click="btnClick(1)">替换</a>-->
        <!--<a class="ui-btn cancel" @click="btnClick(2)">追加</a>-->
        <!--<a class="ui-btn cancel" @click="btnClick(3)">跳过</a>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    btnClose (){
      this.$emit('btnclick', 'close')
    },
    btnClick (val){
      this.$emit('btnclick', val)
    }
  },

  created () {

  }
}
</script>
<style lang="less" scoped>
@import "./Index.less";
.w-rename{
  background: transparent
}
</style>

